import { RouterView, type RouteRecordRaw } from "vue-router";

export const rootRouteId = "__root__" as const;

type VueRouterRecordConfig = Omit<RouteRecordRaw, "path" | "name" | "children">;

export type RouteOptions<> = {
	path: string;
	name?: string;
	children?: Route[];
	validateSearch?: SearchSchemaValidator;
} & VueRouterRecordConfig;

export type SearchSchemaValidator = SearchSchemaValidatorObj | SearchSchemaValidatorFn;
export type SearchSchemaValidatorObj = {
	parse?: SearchSchemaValidatorFn;
};

export type SearchSchemaValidatorFn = (searchObj: Record<string, unknown>) => any;

export class Route {
	options: RouteOptions;

	name!: string;
	suggestedName = "";

	constructor(options: RouteOptions) {
		this.options = options;
	}

	init(parent?: Route) {
		this.#createSuggestedName(parent);

		this.name = this.options.name ? this.options.name : (this.suggestedName as any);

		if (Array.isArray(this.options.children)) {
			this.options.children.forEach((c: Route) => c.init(this));
		}
	}

	get isCustomName() {
		return !!this.options.name;
	}

	#createSuggestedName(parent?: Route) {
		if (this.options.name === rootRouteId) {
			return;
		}

		if (this.options.name && this.options.path === "") {
			this.suggestedName = parent?.suggestedName || "";
			return;
		}

		const prefix = parent?.suggestedName ? `${parent.suggestedName}-` : "";
		let path = this.options.path as string;
		if (!path) {
			this.suggestedName = `${prefix}index`;
			return;
		}

		// Trim / from start and end path
		while (path.charAt(0) === "/") {
			path = path.slice(1);
		}
		while (path.charAt(path.length - 1) === "/") {
			path = path.slice(0, -1);
		}

		this.suggestedName = `${prefix}${path.replaceAll(":", "").split("/").join("-")}`;
	}
}

export class RootRoute extends Route {
	static create({ children }: { children: Route[] }): RootRoute {
		return new this({
			name: rootRouteId,
			path: "",
			component: RouterView,
			children,
		});
	}
}

export class LayoutRoute extends Route {
	constructor(options: RouteOptions) {
		super({
			...options,
			name: `__${options.name}__`,
		});
	}
}
